var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgButtonIndex = function SvgButtonIndex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    preserveAspectRatio: "none",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffce41}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Header_Buttons",
    "data-name": "Header Buttons"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.94,
    cy: 9.65,
    r: 2.77,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.32,
    cy: 19.83,
    r: 2.77,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.94,
    cy: 30.35,
    r: 2.77,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7.37v4.38l19.8.99-.41-5.86zM13.99 17.59l.41 3.56 19.27.9.64-5.33zM14.63 28.1l-.38 4.09 19.8.5-.67-5.13z",
    className: "cls-1"
  }))));
};
export default SvgButtonIndex;